import { IonCheckbox } from '@ionic/react'
import React, { useMemo } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import useUser from '../../../../contexts/hooks/useUser'
import { useContract } from '../../../../hooks/useContract'
import { trpc } from '../../../../modules/trpc'
import { GeneralContactFormFields } from '../GeneralContactModal'

interface ChooseContactCategoryStepProps {
	form: UseFormReturn<GeneralContactFormFields>
}

const ChooseContactCategoryStep: React.FC<ChooseContactCategoryStepProps> = ({ form }) => {
	const { t } = useTranslation('modals_generalContact')
	const { user } = useUser()

	const { contractData: contractInfo } = useContract()

	const { data: synerallUser } = trpc.synerall.userByPid.useQuery(
		{ personalId: user?.personalId ?? '' },
		{ enabled: user?.personalId !== undefined }
	)

	const ownerCategories = [
		{
			label: t('categoryStep.contract'),
		},
		{
			label: t('categoryStep.billing'),
		},
		{
			label: t('categoryStep.contactInformation'),
		},
	]

	const generalCategories = [
		{
			label: t('categoryStep.newContract'),
		},
		{
			label: t('categoryStep.noContract'),
		},
	]

	const allCategories = [...ownerCategories, ...generalCategories]

	const isOwner = useMemo(() => {
		if (!contractInfo || !synerallUser) return false
		return synerallUser.Id === contractInfo.CustomerID
	}, [contractInfo, synerallUser])

	const categories = useMemo(() => {
		return isOwner ? allCategories : generalCategories
	}, [isOwner, allCategories, generalCategories])

	const onCategoryClick = (category: string) => {
		form.setValue('category', category)
	}

	return (
		<div>
			<div id='invoices' style={{ paddingBottom: 0 }}>
				<div id='invoice-list' style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
					{categories.map((category, i) => (
						<div key={i} onClick={() => onCategoryClick(category.label)} className='invoice-card'>
							<div className='flex flex-row items-center pl-2 gap-4 text-white'>
								<IonCheckbox
									className='[--size:32px] mr-0 dark:[--border-color:#3cb49f] dark:[--border-color-checked:#3cb49f] dark:[--checkbox-background-checked:#3cb49f] dark:[--checkbox-background:#144448] [--border-color:#52ae32] [--border-color-checked:#52ae32] [--checkbox-background-checked:#52ae32] [--checkbox-background:#cae3cc]'
									checked={form.watch('category') === category.label}
								/>
								<div className='text-text-dark dark:text-white'>{category.label}</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	)
}

export default ChooseContactCategoryStep
